import styled from 'styled-components';


export const InitiativesContainer = styled.div`
  width: 100%;
  margin:16px 0px 0px 0px;
  .icon-name{
 display:flex;
 align-items: center;
 margin-bottom:20px;
}
  .icon{
      background: ${({ background }) => background ? background : '#F6D5D6'};
      border-radius:50%;
      width:48px;
      height:48px;
      display:flex;
      align-items:center;
      justify-content:center;
    }
  .initiative-image{
    width:24px;
    height:24px;
  }

.name{
   margin-left:12px;
   color: var(--Font-Color-on-Light-theme-500, #184A61);
font-family: Lato;
font-size: 18px;
font-style: normal;
font-weight: 700;
line-height: 24px;
 }

 .ini-name{
   margin-top:20px;
   color: #184A61;
font-family: Lato;
font-size: 18px;
font-style: normal;
font-weight: 700;
line-height: 24px;
 }


 .about{
    color: #184A61;
font-family: Lato;
font-size: 16px;
font-style: normal;
font-weight: 400;
line-height: 20px;

margin-top:12px;
max-height: 200px;
overflow-y:auto;
 }
  .details{
    width: 100%;
    margin: auto;
    font-family: Rubik;
    font-size: 18px; // 16px;
    line-height: 24px; // 25.8px;
    color: #005C87; //#0D4270;
    text-align: center;
    padding: 0px 20px 0px 20px;
  }

  .greatText{
    font-family: Rubik-Medium;
    font-size: 24px;
    line-height: 24px;
    color: ${({color}) => color ? color : '#0D4270'};
    text-align: center;
    margin-bottom: 10px;
    margin-top: 10px;
  }
  .completionText{
    font-family: Rubik
    font-size: 16px;
    line-height: 16px;
    color:#0D4270;
    text-align: center;
    margin-bottom: 25px;
  }
  .initiativeText{
    font-family: Rubik-Medium;
    font-size: 18px;
    line-height: 20px;
    color:#0D4270;
    margin-bottom: 15px;
    text-align: center;
  }
  .congratulationText{
    font-family: Rubik-Medium;
    font-size: 18px;
    line-height: 20px;
    color: ${({color}) => color ? color : '#0D4270'};
    margin-bottom: 30px;
    text-align: center;
  }
`;


export const HeaderWrapper = styled.div`
  ${'' /* color: #005c87; */}
  ${'' /* margin-top: 20px; */}
  display: flex;
  justify-content: center;
  align-items: center;

  color:#184A61;

/* Primary - Lato/Sub Heading */
font-family: Lato;
font-size: 18px;
font-style: normal;
font-weight: 700;
line-height: 24px;
`;

export const HeaderText = styled.span`
color: var(--Font-Color-on-Light-theme-500, #184A61);
font-family: Lato;
font-size: 18px;
font-style: normal;
font-weight: 700;
line-height: 24px;
  margin-left: 10px;
`;

export const StyledBorder = styled.div`
  background: rgba(0, 92, 135, 0.1);
  margin: 20px 0 0 0;
  height: 1px;
`;

export const CenterText = styled.div`
color: #184A61;
text-align: center;
font-family: Lato;
font-size: 16px;
font-style: normal;
font-weight: 400;
line-height: 20px;
`;

export const InitiativeName = styled.div`
  margin-top: 4px;
`;

export const InitiativeIcon = styled.div`
  margin: 20px 0px;
  width:100%;
  display:flex;
  align-items:center;
  justify-content:center;


  .icon{
      background: ${({ background }) => background ? background : '#F6D5D6'};
      border-radius:50%;
      width:48px;
      height:48px;
      display:flex;
      align-items:center;
      justify-content:center;
      ${'' /* margin-bottom:20px; */}
    }
  .initiative-image{
    width:24px;
    height:24px;
  }
`;

export const CongratsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const CongratsTitle = styled.div`
color:#184A61;
text-align: center;
font-family: Lato;
font-size: 18px;
font-style: normal;
font-weight: 700;
line-height: 24px;
`;

export const CongratsSubText = styled.div`
color: #184A61;
text-align: center;
font-family: Lato;
font-size: 16px;
font-style: normal;
font-weight: 400;
line-height: 20px; 
margin-top:12px;
`;

export const ConfirmBtn = styled.button`
  margin: 30px auto 5px auto;
  width: 352px;
  background: #007ab1;
`;

